import { render, staticRenderFns } from "./IdentificacaoOperadora.vue?vue&type=template&id=06f4427a"
import script from "./IdentificacaoOperadora.vue?vue&type=script&lang=js"
export * from "./IdentificacaoOperadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports